export default "__VITE_ASSET__BMqx6swg__"